"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var shortid_1 = __importDefault(require("shortid"));
var LabelTooltipDecorator_1 = __importDefault(require("../label-tooltip-decorator/LabelTooltipDecorator"));
var interfaces_1 = require("../label-tooltip-decorator/interfaces");
var utils_1 = require("../../utils");
var RightDecoratorsPropTypes = {
    rightDecorators: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
};
var InputDecoratorPropTypes = __assign(__assign({}, interfaces_1.LabelTooltipDecoratorPropTypes), RightDecoratorsPropTypes);
var InputDecorator = function (_a) {
    var rightDecorators = _a.rightDecorators, label = _a.label, tooltip = _a.tooltip, tooltipCloseLabel = _a.tooltipCloseLabel, showRequired = _a.showRequired, className = _a.className, children = _a.children, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onInit = _a.onInit, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onValidationChanged = _a.onValidationChanged, rest = __rest(_a, ["rightDecorators", "label", "tooltip", "tooltipCloseLabel", "showRequired", "className", "children", "onInit", "onValidationChanged"]);
    var child;
    if (React.Children.count(children) > 1) {
        throw new Error("The Input decorator can wrap only one component. Found: " + React.Children.count(children));
    }
    else if (React.Children.count(children) === 1) {
        child = React.Children.only(children);
        if ((child === null || child === void 0 ? void 0 : child.type) !== 'input') {
            throw new Error("The Input decorator accepts only an \"input\" tag. Found: " + child.type);
        }
    }
    // Generate unique ID if not provided
    var inputId = react_1.useMemo(function () {
        var _a;
        return ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id) || "tk-input-" + shortid_1.default.generate();
    }, [child]);
    var tooltipId = react_1.useMemo(function () { return "tk-hint-" + shortid_1.default.generate(); }, []);
    var disabled = react_1.useMemo(function () {
        var _a;
        return (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.disabled;
    }, [child]);
    var childWithId = react_1.useMemo(function () {
        return child
            ? React.cloneElement(child, {
                onBlur: utils_1.callParentAndChildMethod(rest, child.props, 'onBlur'),
                onChange: utils_1.callParentAndChildMethod(rest, child.props, 'onChange'),
                id: inputId,
                className: classnames_1.default('tk-input', child.props.className),
            })
            : null;
    }, [child]);
    return (React.createElement("div", { className: classnames_1.default('tk-input-group', className, {
            'tk-input-group--disabled': disabled,
        }) },
        React.createElement("div", { className: classnames_1.default('tk-input__container', {
                'tk-input__container--disabled': disabled,
            }) },
            childWithId,
            rightDecorators ? (React.createElement("span", { className: 'tk-input__right-decorators' }, Array.isArray(rightDecorators)
                ? rightDecorators.map(function (decorator) { return decorator; })
                : rightDecorators)) : null),
        React.createElement(LabelTooltipDecorator_1.default, { id: tooltipId, htmlFor: inputId, label: label, placement: 'top', tooltip: tooltip, tooltipCloseLabel: tooltipCloseLabel, showRequired: showRequired })));
};
InputDecorator.propTypes = InputDecoratorPropTypes;
InputDecorator.displayName = 'InputDecorator';
exports.default = InputDecorator;
